import { Component, computed, effect, inject, untracked } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterLink } from "@angular/router";
import {
  NbActionsModule,
  NbContextMenuModule,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuModule,
  NbMenuService,
  NbThemeService,
  NbUserModule,
} from "@nebular/theme";
import { CourseService } from "app/@core/services/course.service";
import { UserService } from "app/@core/services/users.service";
import { Course } from "app/@core/types";
import { ScriptService } from "app/@core/utils/script.service";
import { MENU_ITEMS, USER_MENU } from "app/app-menu";
import { environment } from "environments/environment";
import { User } from "../../../@core/types";

@Component({
  standalone: true,
  selector: "ngx-header-course",
  styleUrls: ["header-course.component.scss"],
  templateUrl: "header-course.component.html",
  imports: [
    RouterLink,
    NbMenuModule,
    NbActionsModule,
    NbUserModule,
    NbContextMenuModule,
  ],
})
export class HeaderCourseComponent {
  private menuService = inject(NbMenuService);
  private themeService = inject(NbThemeService);
  private breakpointService = inject(NbMediaBreakpointsService);
  private userService = inject(UserService);
  private courseService = inject(CourseService);
  private scriptService = inject(ScriptService);
  private titleService = inject(Title);

  window: any = { Beacon: "" };

  user = this.userService.user;
  course = this.courseService.currentCourse;

  private readonly RAW_MENU: NbMenuItem[] = MENU_ITEMS;
  userMenu: NbMenuItem[] = USER_MENU;

  syncCourse = effect(() => {
    const course = this.courseService.currentCourse();
    const user = this.userService.user();
    if (!course || course.id === 0 || !user || user.email === "") return null;
    if (course?.id !== 0 && user?.email && environment.production) {
      untracked(() => this.initBeacon(course, user));
    }
  });

  readonly mainMenu = computed(() => {
    const hasAces = this.courseService.hasAces();
    const hasAiPlayGround = this.courseService.hasAiPlayGround();
    const isAdmin = this.userService.isAdmin();

    return this.RAW_MENU.map((item) => ({
      ...item,
      hidden:
        item.title === "ACES"
          ? !hasAces
          : item.title === "AI Playground"
            ? !hasAiPlayGround
            : item.title === "Admin"
              ? !isAdmin
              : item.hidden,
    }));
  });

  initBeacon(course: Course, user: User): void {
    if (course?.options) {
      if (course.options.beacon != "") {
        this.scriptService
          .load("beacon")
          .then((data: any) => {
            this.window = data[0].window;
            this.window.Beacon("init", course.options.beacon);
            if (user?.email != "") {
              this.window.Beacon("identify", {
                name: user.firstname + " " + user.lastname,
                email: user.email,
              });
            }
          })
          .catch((error: any) => console.log(error));
      }
    }
  }

  getLink(slug: string): string {
    return `/course/${slug}/notifications`;
  }

  ngOnDestroy() {
    if (typeof this.window.Beacon === "function") {
      this.window.Beacon("destroy");
    }
    this.titleService.setTitle("Mirasee Courses");
  }
}
